module.exports = __webpack_public_path__ + "img/tarjeta-vos.5b71ed51.webp";